import { UpdateBrandingEN } from '@/core/components/help-and-support/quick-answers/update-branding/en'
import { UpdateBrandingES } from '@/core/components/help-and-support/quick-answers/update-branding/es'
import { useIntlSelector } from '@/core/hooks/useIntlSelector'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_layout/dashboard/help-and-support/quick-answers/update-branding/'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { locale } = useIntlSelector()

  switch (locale) {
    case 'en':
      return <UpdateBrandingEN />
    case 'es':
      return <UpdateBrandingES />
  }
}
